import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { mainUserNameValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

const MainUserNameFormFieldMain = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          利用者名 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <FormTextField
          name={props.name}
          placeholder={"例）田中 太郎"}
          registerOptions={{
            validate: mainUserNameValidation,
          }}
          ref={ref}
        />
        <div css={errorWrapper}>
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

export const MainUserNameFormField = React.forwardRef(
  MainUserNameFormFieldMain
);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const errorWrapper = css({
  flex: 1,
});
